import React from 'react';

export type AssetsViewContextValue = "AssetSummary" | "CurrentNetWorth" | "AssetTitling";

const defaultValue: AssetsViewContextValue = "AssetSummary";

export default React.createContext<AssetsViewContextValue>(defaultValue);